import * as React from 'react';
import { Col, ControlLabel, FormControl, FormGroup, Media, Checkbox } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { Translate } from '../../../../shared/LanguageService';
import { ICreateOrderContact } from '../../Entities';
import FieldInfoIcon from '../../../../components/common/FieldInfoIcon';
import InlineTooltip from '../../../../components/common/ToolTip';
import { phoneRegexp, emailRegexp } from '../../../../shared/ValidationRegexp';
import CountryCodePhoneNumberInput from '../../../../components/common/CountryCodePhoneNumberInput';

interface IScandphotosCreateOrderCompletePageProps {
    orderAdditions: any[];
    selectedOrderAdditions: number[];
    onSelectedOrderAdditions: (id: number) => void;
    otherInfo: any;
    contactInfo: ICreateOrderContact;
    onChange(collection: string, key: string, evt: any);
    existingPlanOrderId?: number;
}

class ScandphotosCreateOrderCompletePage extends React.Component<
    IScandphotosCreateOrderCompletePageProps,
    any
> {
    constructor(props: any, context: any) {
        super(props, context);
        this.phoneNumberValidator.bind(this.phoneNumberValidator);
        this.state = {
            selectedAdditionPackages: []
        };
    }

    phoneNumberValidator(phoneNumber: string): 'success' | 'warning' | 'error' {
        if (!phoneRegexp.test(phoneNumber) && phoneNumber !== '') {
            return 'error';
        }
    }

    emailValidator(email: string): 'success' | 'warning' | 'error' {
        if (!emailRegexp.test(email) && email !== '') {
            return 'error';
        }
    }

    render() {
        return (
            <fieldset>
                <Col md={6}>
                    <ControlLabel>
                        {Translate(
                            'scandphotos/orders/create/subview/order-complete/label/additions'
                        )}
                    </ControlLabel>
                    {this.props.existingPlanOrderId && (
                        <Link
                            className="existing-plan-order-link scandphotos"
                            target="_blank"
                            to={`/orders/${this.props.existingPlanOrderId}`}
                        >
                            {Translate('orders/create/plan-order-exists')}
                        </Link>
                    )}
                    <FormGroup>
                        {this.props.orderAdditions.map((pkg, index) => {
                            return (
                                <Checkbox
                                    className="select-product"
                                    disabled={pkg.required}
                                    key={`additions${index}`}
                                    checked={this.props.selectedOrderAdditions.indexOf(pkg.id) >= 0}
                                    onChange={() => {
                                        this.props.onSelectedOrderAdditions(pkg.id);
                                    }}
                                >
                                    <Media
                                        className={
                                            'product-box extras' + (pkg.required ? ' required' : '')
                                        }
                                    >
                                        <Media.Left align="middle">
                                            <i className="material-icons">add_circle_outline</i>
                                        </Media.Left>
                                        <Media.Body>
                                            <h5>{pkg.name}</h5>
                                            <InlineTooltip id={pkg.id} tooltip={pkg.extraText} />
                                        </Media.Body>
                                    </Media>
                                </Checkbox>
                            );
                        })}
                    </FormGroup>
                </Col>
                <Col md={6}>
                    <FormGroup>
                        <ControlLabel>
                            {Translate(
                                'scandphotos/orders/create/subview/order-complete/label/other-information'
                            )}
                        </ControlLabel>
                        <FormControl
                            componentClass="textarea"
                            value={this.props.otherInfo.notes}
                            onChange={(value) => {
                                this.props.onChange('otherInfo', 'notes', value);
                            }}
                            placeholder=""
                        />
                    </FormGroup>
                    {this.props.orderAdditions
                        .filter((x: any) => this.props.selectedOrderAdditions.indexOf(x.id) >= 0)
                        .filter((x: any) => x.requiredOwnerMobilePhoneNumber).length > 0 && (
                        <FormGroup
                            validationState={this.phoneNumberValidator(
                                this.props.contactInfo.ownerPrimaryPhoneNumber
                            )}
                            className="required"
                        >
                            <ControlLabel>
                                {Translate(
                                    'scandphotos/orders/create/subview/order-contact/label/mobile-phone'
                                )}
                            </ControlLabel>
                            <FieldInfoIcon
                                title={Translate('popover/info/title/phonenumber')}
                                content={Translate('popover/info/content/phonenumber')}
                            />
                            <CountryCodePhoneNumberInput
                                value={
                                    this.props.contactInfo &&
                                    this.props.contactInfo.ownerPrimaryPhoneNumber
                                        ? this.props.contactInfo.ownerPrimaryPhoneNumber
                                        : ''
                                }
                                onChange={(value) => {
                                    this.props.onChange('contactInfo', 'ownerPrimaryPhoneNumber', value);
                                }}
                            />
                        </FormGroup>
                    )}
                    {this.props.orderAdditions
                        .filter((x: any) => this.props.selectedOrderAdditions.indexOf(x.id) >= 0)
                        .filter((x: any) => x.requiredOwnerEmailAddress).length > 0 && (
                        <FormGroup
                            validationState={this.emailValidator(
                                this.props.contactInfo.ownerEmailAddress
                            )}
                            className="required"
                        >
                            <ControlLabel>
                                {Translate(
                                    'scandphotos/orders/create/subview/order-contact/label/owner-email-address'
                                )}
                            </ControlLabel>
                            <FieldInfoIcon
                                title={Translate('popover/info/title/owner-email-address')}
                                content={Translate('popover/info/content/owner-email-address')}
                            />
                            <FormControl
                                type="text"
                                value={
                                    this.props.contactInfo &&
                                    this.props.contactInfo.ownerEmailAddress
                                        ? this.props.contactInfo.ownerEmailAddress
                                        : ''
                                }
                                onChange={(value) => {
                                    this.props.onChange('contactInfo', 'ownerEmailAddress', value);
                                }}
                            />
                        </FormGroup>
                    )}
                </Col>
            </fieldset>
        );
    }
}
export default ScandphotosCreateOrderCompletePage;
